











import { Component, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { BibliographySetDetailMarc } from '@/api'
import {
  Col,
  DataTable,
  findSortColumnItem,
  setSortOrder,
  SortColumn
} from '@/components/molecules/DataTable'
import { orderBy } from 'lodash'
import { SortOrder } from '@/types'

const COLS: Col[] = [
  {
    width: '20',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'marcTag',
        headerText: 'タグ',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '20',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'stringLength',
        headerText: 'バイト／文字列',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '60',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'data',
        headerText: '詳細データ',
        sortable: true,
        sortOrder: ''
      }
    ]
  }
]

@Component({
  components: { DataTable }
})
export default class CollectionMagazineNameMarcTable extends ComponentVue {
  @Prop({
    type: Array,
    default: () => []
  })
  items!: BibliographySetDetailMarc[]

  @Prop({
    type: Number,
    required: true
  })
  height!: number

  sortName: string = ''

  sortOrder: SortOrder = ''

  get cols(): Col[] {
    return COLS
  }

  get sortedItems(): BibliographySetDetailMarc[] {
    if (this.sortName) {
      return orderBy<BibliographySetDetailMarc>(
        this.items,
        this.sortName,
        this.sortOrder as 'asc' | 'desc'[]
      )
    }
    return this.items
  }

  onSort(sortColumn: SortColumn) {
    setSortOrder(this.cols, sortColumn)

    const sortColItem = findSortColumnItem(this.cols)

    this.sortName = sortColItem?.name ?? ''
    this.sortOrder = sortColItem?.sortOrder ?? ''
  }
}
